export interface ParsedFooterFAQContent {
    introHtml: string;
    faqItems: Array<{
        title: string;
        content: string;
    }>;
}

export interface ParsedHtmlElement {
    tagName: string;
    textContent: string | null;
    outerHTML: string;
}

/** Shared parsing loop for CMS directory footer HTML. */
export const buildParsedFooterFAQContent = (
    bodyChildren: ParsedHtmlElement[],
): ParsedFooterFAQContent => {
    let introHtml = '';
    const faqItems: Array<{ title: string; contentParts: string[] }> = [];

    let currentFAQ: { title: string; contentParts: string[] } | null = null;
    let hasFoundFirstParagraph = false;
    let hasFoundFirstHeading = false;

    bodyChildren.forEach((element) => {
        const tagName = element.tagName.toLowerCase();

        if (tagName === 'h2' || tagName === 'h3') {
            hasFoundFirstHeading = true;

            if (currentFAQ && currentFAQ.contentParts.length > 0) {
                faqItems.push(currentFAQ);
            }

            currentFAQ = {
                title: element.textContent || '',
                contentParts: [],
            };
            return;
        }

        if (tagName === 'p' && !hasFoundFirstParagraph) {
            hasFoundFirstParagraph = true;
            introHtml = element.outerHTML;
            return;
        }

        if (tagName === 'p' && !hasFoundFirstHeading) {
            faqItems.push({
                title: element.textContent || '',
                contentParts: [],
            });
            return;
        }

        if (currentFAQ) {
            currentFAQ.contentParts.push(element.outerHTML);
        }
    });

    if (currentFAQ !== null) {
        const lastFAQ = currentFAQ as {
            title: string;
            contentParts: string[];
        };
        if (lastFAQ.contentParts.length > 0) {
            faqItems.push(lastFAQ);
        }
    }

    return {
        introHtml,
        faqItems: faqItems.map((item) => ({
            title: item.title,
            content: item.contentParts.join(''),
        })),
    };
};
